module.exports = __webpack_public_path__ + "static/media/01.Tala.75f61af0.JPG";